import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconExitSidePanel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "18px",
	height: "18px",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Asset-Artboard-Page",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Icon_Exit_Side-Panel",
			stroke: "#000000",
			strokeWidth: 1.5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.81416216,8.81416216 L17.6283243,17.6283243 L8.81416216,8.81416216 L-1.3500312e-13,17.6283243 L8.81416216,8.81416216 Z M8.81416216,8.81416216 L-1.3500312e-13,-1.24344979e-14 L8.81416216,8.81416216 L17.6283243,-1.24344979e-14 L8.81416216,8.81416216 Z",
				id: "Combined-Shape"
			})
		})
	})
});
export default SvgIconExitSidePanel;
